module.exports = __webpack_public_path__ + "img/Tessellate04.3c11bb3e.jpg";